import { useMemo } from 'react';
import { ORGANISATION } from 'switch-shared/types/general.enums';

export const useOrganisation = (): ORGANISATION => {
  const organisation = useMemo(() => {
    const env = process.env.REACT_APP_BRAND || 'switch';

    switch (env.toLowerCase()) {
      case 'metermate':
        return ORGANISATION.METER_MATE;
      case 'manuflo':
        return ORGANISATION.MANUFLO;
      case 'hydrowellness':
        return ORGANISATION.HYDRO_WELLNESS;
      case 'joat':
        return ORGANISATION.JOAT;
      case 'hibred':
        return ORGANISATION.HIBRED;
      case 'exprop':
        return ORGANISATION.EXPROP;
      case 'nuleaf':
        return ORGANISATION.NULEAF;
      case 'floutility':
        return ORGANISATION.FLOUTILITY;
      case 'akata':
        return ORGANISATION.AKATA;
      case 'paysmart':
        return ORGANISATION.PAYSMART;
      case 'mbl':
        return ORGANISATION.MBL;
      case 'switch':
      default:
        return ORGANISATION.SWITCH;
    }
  }, []);

  return organisation;
};
